import React, { useState } from 'react';
import Topbar from '../components/Topbar';
import { useApp } from '../context/AppContext';
import { LogOut, User } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const Profile = ({ onDeposit }) => {
  const { user, logout } = useApp();
  const [displayName, setDisplayName] = useState(user?.display_name || '');
  const [email, setEmail] = useState('');
  const [telegram, setTelegram] = useState('');

  const save = () => {
    toast({ title: 'Profile updated', description: 'Your changes have been saved locally.' });
  };

  return (
    <div>
      <Topbar count={1} title="PROFILE" subtitleUnit="Account" onDeposit={onDeposit} />
      <div className="px-8 py-6 font-mono max-w-[720px]">
        <div className="border border-[#151515] rounded-md p-6 bg-[#0a0a0a] mb-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-full bg-[#0f1a12] border border-[#22c55e]/40 flex items-center justify-center text-[#22c55e]">
              <User size={22} />
            </div>
            <div>
              <div className="text-[13px] tracking-wide text-[#e6e6e6]">{user?.display_name}</div>
              <div className="text-[11px] text-[#7a7a7a]">@{user?.username}</div>
            </div>
            <button
              onClick={logout}
              className="ml-auto flex items-center gap-2 text-[11px] tracking-[0.2em] px-3 py-2 rounded-md border border-[#1f1f1f] text-[#8a8a8a] hover:border-[#ef4444] hover:text-[#ef4444] transition-colors"
            >
              <LogOut size={13} /> LOGOUT
            </button>
          </div>
        </div>

        <div className="border border-[#151515] rounded-md p-6 bg-[#0a0a0a] space-y-4">
          <div>
            <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1.5">DISPLAY NAME</label>
            <input
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1.5">EMAIL (OPTIONAL)</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.25em] text-[#7a7a7a] mb-1.5">TELEGRAM HANDLE</label>
            <input
              value={telegram}
              onChange={(e) => setTelegram(e.target.value)}
              placeholder="@yourhandle"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm text-[#e6e6e6] outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          <button
            onClick={save}
            className="mt-2 px-5 py-2 text-[11px] tracking-[0.25em] rounded-md bg-[#166534] hover:bg-[#15803d] text-[#e7ffef] transition-colors"
          >SAVE CHANGES</button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
